import { render, staticRenderFns } from "./differs.vue?vue&type=template&id=dfe9480a&scoped=true"
import script from "./differs.vue?vue&type=script&lang=js"
export * from "./differs.vue?vue&type=script&lang=js"
import style0 from "./differs.vue?vue&type=style&index=0&id=dfe9480a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe9480a",
  null
  
)

export default component.exports